<template>
<div class="container">
<b-row >
<b-container>
	<h3 ><b><i>{{f_titulo_orden_compra()}}</i></b></h3>
            <md-button style="background-color: #2e507a; width: 35px; height: 35px;" class="md-fab md-primary" @click="f_creaOrden()" :disabled="isVigenciaBloqueada">
                <md-icon>add</md-icon>
            </md-button>

	<b-row v-if="!crea_orden && !para_aprobacion" class="mb-4 align-items-center text-lg">
		<!-- Tabla -->
		<b-row>
			<b-col md="12">
				<div class="table-responsive custom-scroll-container" ref="scrollContainer">
					<table class="table table-hover table-bordered">
						<thead style="background-color: #4a90e2;">
							<tr>
								<th scope="col" class="text-center text-white border-0" style="font-weight: 600;">Numero</th>
								<th scope="col" class="text-center text-white border-0" style="font-weight: 600;">Tipo</th>
								<th scope="col" class="text-center text-white border-0" style="font-weight: 600;">Descripcion</th>
								<th scope="col" class="text-center text-white border-0" style="font-weight: 600;">Fecha</th>
								<th scope="col" class="text-center text-white border-0" style="font-weight: 600;">Identificacion</th>
								<th scope="col" class="text-center text-white border-0" style="font-weight: 600;">Nombre</th>
								<th scope="col" class="text-center text-white border-0" style="font-weight: 600;">Items</th>
								<th scope="col" class="text-center text-white border-0" style="font-weight: 600;">Valor Total</th>
								<th scope="col" class="text-center text-white border-0" style="font-weight: 600;">Estado</th>
								<th scope="col" class="text-center text-white border-0" style="font-weight: 600;">Descripcion</th>
							</tr>
						</thead>

						<tbody>
							<tr v-for="ordenCompra in listOrdenCompra" :key="ordenCompra.id" @click="editaOrden(ordenCompra)">
								<td class="text-center"><strong class="text-dark">{{ ordenCompra.numero }}</strong></td>
								<td class="text-left">{{ ordenCompra.tipo }}</td>
								<td class="text-left">{{ ordenCompra.tipo_desc }}</td>
								<td class="text-left">{{ ordenCompra.fecha }}</td>
								<td class="text-left">{{ ordenCompra.identificacion }}</td>
								<td class="text-left">{{ ordenCompra.identificacion_desc }}</td>
								<td class="text-left">{{ ordenCompra.items }}</td>
								<td class="text-right">{{ formato(ordenCompra.valor_total) }}</td>
								<td class="text-left">{{ ordenCompra.estado }}</td>
								<td class="text-left">{{ ordenCompra.estado_desc }}</td>
							</tr>
						</tbody>
					</table>
				</div>
			</b-col>
		</b-row>
	</b-row>

	<b-row  v-if="crea_orden || para_aprobacion">
		<b-col md="7" lg="auto" class="mt-2 mx-auto">
			<b-form id="create-form">
				<b-row class="mt-3">
					<b-col v-if="this.$route.name == 'compras'" cols="3" class="text-left">
						<h5>Orden de Compra</h5>
					</b-col>
					<b-col v-else cols="3" class="text-left">
						<h5>Orden de Servicio</h5>
					</b-col>
					<b-col cols="2" class="text-left">
						<input type="number" v-model="ordenCompra.orden_compra" class="form-control">
					</b-col>
					<b-col cols="1" class="text-left">
						<h5>Tipo</h5>
					</b-col>
					<b-col v-if="this.$route.name == 'compras'" cols="3" class="text-left">
						<select class="form-control" v-model="ordenCompra.tipo" >
						<option value="" default>Seleccionar.....</option>
						<option value="1">Utiles de Oficina</option>
						<option value="2">Implementos de Aseo</option>
						<option value="3">Materiales de Construccion</option>
						<option value="4">Vehiculos</option>
						<option value="5">Equipos de Oficina</option>
						<option value="6">Equipos de Computos</option>
						</select>
					</b-col>
					<b-col v-else cols="3" class="text-left">
						<select class="form-control" v-model="ordenCompra.tipo" >
						<option value="" default>Seleccionar.....</option>
						<option value="1">Servicios Varios</option>
						<option value="2">Asesorias Contables</option>
						<option value="3">Mantenimiento de Software</option>
						<option value="4">Mantenimiento de Hardware</option>
						<option value="5">Asesorias Financieras</option>
						<option value="6">Asesorias de Imagen</option>
						</select>
					</b-col>
					<b-col cols="1" class="text-left">
						<h5>Fecha</h5>
					</b-col>
					<b-col cols="2" class="text-left">
						<input type="date" v-model="ordenCompra.fecha" class="form-control">
					</b-col>
				</b-row>
				<b-row class="mt-3 justify-content-center">
					<b-col cols="3" class="text-left">
						<h5>Proveedor</h5>
					</b-col>
					<b-col cols="9" class="justify-content-center">
						<select class="form-control" v-model="ordenCompra.proveedor" @click="f_seleccione_productos">
						<option value="" default>Seleccionar.....</option>
							<option v-for="proveedores in listProveedores" :key="proveedores.identificacion" :value="proveedores.identificacion">{{ proveedores.nombre }}</option>
						</select>
					</b-col>
				</b-row>
				<b-row class="mt-3">
					<b-col cols="3" class="text-left">
						<h5>Items</h5>
					</b-col>
					<b-col cols="2" class="text-left">
						<input type="number" v-model="ordenCompra.items" class="form-control" readonly>
					</b-col>
					<b-col cols="1" class="text-left">
						<h5>Total</h5>
					</b-col>
					<b-col cols="4" class="text-left">
						<h5>{{formatNumber(ordenCompra.total)}}</h5>
					</b-col>
				</b-row>
			</b-form>
		</b-col>
	</b-row >
	<b-row v-if="ordenCompra.items>0">
		<b-col v-if="!ordenValidada && crea_orden">
		<md-button class="md-raised md-primary" @click="validaOrden()">
			<b><i><h3>Validar</h3></i></b>
		</md-button>
		</b-col>
		<b-col v-if="!ordenValidada && crea_orden">
		<md-button class="md-raised md-primary" @click="creaOrden(0)">
			<b><i><h3>Pendiente</h3></i></b>
		</md-button>
		</b-col>
		<b-col v-if="ordenValidada && crea_orden">
		<md-button class="md-raised md-primary" @click="creaOrden(1)">
			<b><i><h3>Aceptar</h3></i></b>
		</md-button>
		</b-col>
		<b-col v-if="!crea_orden && para_aprobacion">
		<md-button class="md-raised md-primary" @click="paraAprobar(1)">
			<b><i><h3>Para Aprobar</h3></i></b>
		</md-button>
		</b-col>
		<b-col v-if="!crea_orden && para_aprobacion">
		<md-button class="md-raised md-primary" @click="paraAprobar(3)">
			<b><i><h3>Anular</h3></i></b>
		</md-button>
		</b-col>
		<b-col>
		<md-button class="md-raised md-primary" @click="cierreOrden()">
			<b><i><h3>Cancelar</h3></i></b>
		</md-button>
		</b-col>
	</b-row >

	<div class="row col-md-12 justify-content-center " v-if="listItemsOrden.length != 0 && crea_orden && !para_aprobacion">
		<b-table
			:items="listItemsOrden"
			:fields="fields"
			hover
			bordered
			responsive
			sticky-header="500px"
			small
			class="tblEstandar"
			head-variant="custom-blue"
			@row-clicked="(item) => tipoModificacion(item.id)"
		>
		<template #cell(material)="data">
			<div class="text-left">{{ data.item.material }}</div>
		</template>
		<template #cell(descripcion)="data">
			<div class="text-left">{{ data.item.descripcion }}</div>
		</template>
		<template #cell(cantidad)="data">
			<div class="text-center">{{ data.item.cantidad }}</div>
		</template>
		<template #cell(unidad)="data">
			<div class="text-center">{{ data.item.unidad }}</div>
		</template>
		<template #cell(monto_neto)="data">
			<div class="text-right">{{ formatNumber(data.item.monto_neto) }}</div>
		</template>
		<template #cell(precio_neto)="data">
			<div class="text-right">{{ formatNumber(data.item.precio_neto) }}</div>
		</template>
		</b-table>
	</div>
	<md-table v-if="ordenCompra.proveedor!='' && crea_orden && !para_aprobacion">
		<b-row>
			<b-col md="7" lg="auto" class="mt-2 mx-auto">
				<b-form id="create-form">
					<b-row class="mt-3">
						<b-col cols="7" class="text-left">
							<input type="text" v-model="ordenCompra.material" class="form-control">
						</b-col>
						<b-col cols="1" class="text-left">
							<input type="number" v-model="ordenCompra.cantidad" class="form-control" @blur="f_actualiza_precio_neto">
						</b-col>
						<b-col cols="1" class="text-left">
							<input type="text" v-model="ordenCompra.unidad" class="form-control">
						</b-col>
						<b-col cols="2" class="text-left">
							<input type="number" v-model="ordenCompra.monto_neto" class="form-control" @blur="f_actualiza_precio_neto">
						</b-col>
						<b-col cols="1" class="text-left">
							<md-button style="background-color: #2e507a; width: 35px; height: 35px;" class="md-fab md-primary" @click="creaItem(ordenCompra)">
								<md-icon>add</md-icon>
							</md-button>
						</b-col>
					</b-row>
					<b-row class="mt-3">
						<b-col cols="12" class="text-left">
							<select class="form-control" v-model="ordenCompra.material">
								<option value="">Seleccionar.....</option>
								<option v-for="productos in listProductos" :key="productos.id" :value="productos.referencia_proveedor+'-'+productos.descripcion_proveedor">{{ productos.referencia_proveedor}}-{{productos.descripcion_proveedor}}</option>
							</select>
						</b-col>
					</b-row>
				</b-form>
			</b-col>
		</b-row>
	</md-table>
	<md-table v-if="ordenCompra.items>0  && (crea_orden || para_aprobacion)">
		<b-row class="mt-3">
			<b-col cols="3" class="text-left">
				<h5>Partida Presupuestal </h5>
			</b-col>
			<b-col cols="2" class="text-left">
				<h5>Requerida </h5>
			</b-col>
			<b-col cols="1" class="text-left">
				<h5>{{partidaPresupuestalRequerida}}</h5>
			</b-col>
			<b-col v-if="partidaPresupuestalRequerida === 'SI'" cols="5" class="text-left" pageholder="Partida presupuestal" >
				<input type="text" v-model="partidaPresupuestal" class="form-control">
			</b-col>
			<b-col v-else cols="5" class="text-left">
				<input type="text" v-model="partidaPresupuestal" class="form-control" readonly>
			</b-col>
			<b-col cols="1" class="text-left">
				<h5><input type="checkbox" id="chk1" v-on:change="f_check(1)">&nbsp;
				<label for="chk1">OK</label></h5>
			</b-col>
		</b-row>
		<b-row class="mt-3">
			<b-col cols="3" class="text-left">
				<h5>Cantidad Cotizaciones </h5>
			</b-col>
			<b-col cols="2" class="text-left">
				<h5>Requeridas </h5>
			</b-col>
			<b-col cols="1" class="text-left">
				<h5>{{cantidadCotizaciones}}</h5>
			</b-col>
			<b-col cols="5" class="text-left"></b-col>
			<b-col cols="1" class="text-left">
				<h5><input type="checkbox" id="chk2" v-on:change="f_check(2)">&nbsp;
				<label for="chk2">OK</label></h5>
			</b-col>
		</b-row>
		<b-row class="mt-3">
			<b-col cols="3" class="text-left">
				<h5>Aprobacion Proveedor </h5>
			</b-col>
			<b-col cols="2" class="text-left">
				<h5>Requerido </h5>
			</b-col>
			<b-col cols="1" class="text-left">
				<h5>{{aprobacionProveedorRequerido}}</h5>
			</b-col>
			<b-col cols="5" class="text-left"></b-col>
			<b-col cols="1" class="text-left">
				<h5><input type="checkbox" id="chk3" v-on:change="f_check(3)">&nbsp;
				<label for="chk3">OK</label></h5>
			</b-col>
		</b-row>
		<b-row class="mt-3">
			<b-col cols="3" class="text-left">
				<h5>Nivel Aprobacion </h5>
			</b-col>
			<b-col cols="2" class="text-left">
				<h5>Minimo </h5>
			</b-col>
			<b-col cols="1" class="text-left">
				<h5>{{nivelAprobacion}}</h5>
			</b-col>
			<b-col cols="2" class="text-left">
				<h5>Aprobador</h5>
			</b-col>
			<b-col cols="3" class="text-left">
				<h5>{{aprobadorPorDefecto}}</h5>
			</b-col>
			<b-col cols="1" class="text-left"></b-col>
		</b-row>
		<b-row class="mt-3">
			<b-col cols="3" class="text-left">
				<h5>Aprobadores</h5>
			</b-col>
			<b-col cols="9" class="text-left">
				<h5>{{aprobadores}}</h5>
			</b-col>
		</b-row>
	</md-table>

</b-container>

</b-row>
</div>
</template>
<script>
import Factura from "@/services/Facturas"
import User from "@/services/User"
import Razon from "@/services/Razones"
import Estado from "@/services/Estados"
import Ordenes from "@/services/Ordenes"

export default {
name:'Facturas',
data: () => ({
	crea_orden:false,
	para_aprobacion:false,
	users : [],
	listPaises : [],
	listRazones : [],
	listRazonesLeidas : [],
	listEstados : [],
	listProveedores : [],
	listProductos : [],
	listItemsOrden : [],
	listOrdenCompra : [],
	pais : 'PERU',
	muestreDetalleOrden: false,
	muestreConsultaOrden: false,
	ordenCompra: { proveedor:''},
	partidaPresupuestalRequerida: "NO",
	partidaPresupuestal: "",
	partidaPresupuestalOK: false,
	cantidadCotizaciones: 3,
	cantidadCotizacionesOK: false,
	aprobacionProveedorRequerido: "NO",
	aprobacionProveedorOK: false,
	aprobadorPorDefecto: "",
	nivelAprobacion : 2,
	tipoOrdenesCompra : [],
	tipoOrdenesAprobaciones : [],
	tipoOrdenesAprobador : [],
	aprobadores: '',
	ordenValidada: false,
	documento : "",
}),
computed:{
labels(){
	if (this.$store.state._language == "es-ES") {
		return {
			title : "FACTURAS",
			documento : "Tipo",
			factura : "Número Factura",
			fecha : "Fecha Factura",
			identificacion : "Número Identificación",
			proveedor : "Nombre del Proveedor",
			cantidad_facturas : "Facturas",
			pedido : "Número Pedido",
			valor : "Valor Bruto",
			impuesto0 : "Impuesto0",
			categoria0 : "Categoria0",
			impuesto1 : "Impuesto1",
			categoria1 : "Categoria1",
			impuesto2 : "Impuesto2",
			categoria2 : "Categoria2",
			impuesto_tot : "Total Impuesto",
			valor_total : "Total Factura",
			items : "Items",
			item : "Item",
			descripcion : "Descripcion",
			precioFE : "PrecioFE",
			precioSAP : "PrecioSAP",
			cantidadFE : "CantFE",
			cantidadSAP : "CantSAP",
			ivaFE : "IvaFE",
			ivaSAP : "IvaSAP",
			impuestoFE : "ImpFE",
			impuestoSAP : "ImpSAP",
			diferencia_total : "DifTotal",
			valor_fe : "TotalFE",
			valor_sap : "TotalSAP",
			usuario : "Usuario",
			cantidad: "Cantidad",
			codigo: "Codido",
			descripcion_item: "Descripcion Producto --------------------------------",
			descripcion_item_orden: "Descripcion Orden Compra ----------------------------------------------",
			descripcion_novedad: "Descripcion ----------------------------------------------------------------------------------------",
			unidad: "UnEmpa",
			unitario: "Monto",
			venta_bruta: "Precio Ord",
			venta_bruta_factura: "Precio Fac",
			item_factura: "Item Fac",
			impuesto: "Impuesto",
			cantidad_facturada: "Cant Fac",
			precio_facturado: "Precio Fac",
			valoresQ: "Q SAP",
			valoresP: "P SAP",
			diferenciasQ: "DIFER Q",
			diferenciasP: "DIFER P",
			monto_facturado: "Monto Fac",
			iva: "IGV",
			otroImpuesto : "Imp Adic",
			estado: "Estado",
		}
	}else{
		return {
			title : "INVOICES",
			factura : "Invoice",
			fecha : "Date",
			identificacion : "Identification",
			proveedor : "Name",
			cantidad : "Invoices",
			pedido : "Order",
			valor : "Amount",
			impuesto0 : "Tax0",
			categoria0 : "Category0",
			impuesto1 : "Tax1",
			categoria1 : "Category1",
			impuesto2 : "Tax2",
			categoria2 : "Category2",
			impuesto : "Taxes",
			valor_total : "Total Amount",
			items : "Items",
			item : "Item",
			descripcion : "Description",
			diferencia_precio : "Price Dif",
			diferencia_cantidad : "Amount Dif",
			diferencia_iva : "Iva Dif",
			diferencia_impuesto : "Other Tax Dif",
			diferencia_Total : "Total",
			diferencia_total : "Total Dif",
			valor_fe : "FE Value",
			valor_sap : "SAP Value",
		}
	}
}
},
mounted(){

	User.getAllUsers(this.$store.state.userName)
	.then((result) => {
		this.users = result.data.users;
	})
	.catch((err) => {
		console.log(err)
	})
        Razon.leaRazones()
        .then((res) => {
            this.listRazonesLeidas = res.data.listRazones
        })
        .catch((err) => {
            console.log(err)
        })
        Estado.leaEstados(false)
        .then((res) => {
            this.listEstados = res.data.listEstados
        })
        .catch((err) => {
            console.log(err)
        })
        Factura.leaPaises(false)
        .then((res) => {
            this.listPaises = res.data.listPaises
        })
        .catch((err) => {
            console.log(err)
        })
	Factura.leaProv(this.pais)
	.then((res) => {
		this.listProveedores = res.data.listProveedores
	})
	.catch((err) => {
		console.log(err)
	})
	if	(this.$route.name == "compras") {
		this.documento="OC"
	} else {
		this.documento="OS"
	}
	Ordenes.tiposOrdenesCompra(this.documento)
	.then((res) => {
		this.tipoOrdenesCompra = res.data.tiposOrdenesCompra
	})
	Ordenes.tiposOrdenesAprobaciones(this.documento)
	.then((res) => {
		this.tipoOrdenesAprobaciones = res.data.tiposOrdenesAprobaciones
	})
	Ordenes.tiposOrdenesAprobador(this.documento)
	.then((res) => {
		this.tipoOrdenesAprobador = res.data.tiposOrdenesAprobador
	})

	Ordenes.listaOrdenes(this.documento,this.$store.state.userId,0)
	.then((res) => {
		this.listOrdenCompra = res.data.listOrdenCompra
		this.listOrdenCompra.forEach((orden) => {
			const v_proveedor = this.listProveedores.find((proveedor) => proveedor.identificacion == orden.identificacion)
			orden.identificacion_desc = v_proveedor.nombre
			if	(orden.documento == "OC") {
				orden.tipo_desc = "Tipo "+orden.tipo
				switch (orden.tipo) {
					case	1: orden.tipo_desc = "Utiles de Oficina";break
					case	2: orden.tipo_desc = "Implementos de Aseo";break
					case	3: orden.tipo_desc = "Materiales de Construccion";break
					case	4: orden.tipo_desc = "Vehiculos";break
					case	5: orden.tipo_desc = "Equipos de Oficina";break
					case	6: orden.tipo_desc = "Equipos de Computos";break
				}
			} else {
				orden.tipo_desc = "Tipo "+orden.tipo
				switch	(orden.tipo) {
					case	1: orden.tipo_desc = "Servicios Varios";break
					case	2: orden.tipo_desc = "Asesorias Contables";break
					case	3: orden.tipo_desc = "Mantenimiento de Software";break
					case	4: orden.tipo_desc = "Mantenimiento de Hardware";break
					case	5: orden.tipo_desc = "Asesorias Financieras";break
					case	6: orden.tipo_desc = "Asesorias de Imagen";break
				}
			}
			switch	(orden.estado) {
				case	0: orden.estado_desc = "Pendiente";break
				case	1: orden.estado_desc = "Para Aprobacion";break
				case	2: orden.estado_desc = "Aprobada";break
				case	3: orden.estado_desc = "Anulada";break
			}
		})
	})

},
methods:{
	paraAprobar(estado) {
		Ordenes.apruebaOrden(this.ordenCompra.id,estado,this.$store.state.userId)
		.then((res) => {
			if	(res.status == 200) {
				this.$toast.success("Orden Para Aprobacion")
				Ordenes.listaOrdenes(this.documento,this.$store.state.userId,0)
				.then((res) => {
					this.listOrdenCompra = res.data.listOrdenCompra
					this.listOrdenCompra.forEach((orden) => {
						const v_proveedor = this.listProveedores.find((proveedor) => proveedor.identificacion == orden.identificacion)
						orden.identificacion_desc = v_proveedor.nombre
						if	(orden.documento == "OC") {
							orden.tipo_desc = "Tipo "+orden.tipo
							switch (orden.tipo) {
								case	1: orden.tipo_desc = "Utiles de Oficina";break
								case	2: orden.tipo_desc = "Implementos de Aseo";break
								case	3: orden.tipo_desc = "Materiales de Construccion";break
								case	4: orden.tipo_desc = "Vehiculos";break
								case	5: orden.tipo_desc = "Equipos de Oficina";break
								case	6: orden.tipo_desc = "Equipos de Computos";break
							}
						} else {
							orden.tipo_desc = "Tipo "+orden.tipo
							switch	(orden.tipo) {
								case	1: orden.tipo_desc = "Servicios Varios";break
								case	2: orden.tipo_desc = "Asesorias Contables";break
								case	3: orden.tipo_desc = "Mantenimiento de Software";break
								case	4: orden.tipo_desc = "Mantenimiento de Hardware";break
								case	5: orden.tipo_desc = "Asesorias Financieras";break
								case	6: orden.tipo_desc = "Asesorias de Imagen";break
							}
						}
						switch	(orden.estado) {
							case	0: orden.estado_desc = "Pendiente";break
							case	1: orden.estado_desc = "Para Aprobacion";break
							case	2: orden.estado_desc = "Aprobada";break
							case	3: orden.estado_desc = "Anulada";break
						}
					})
				})

			} else {
				this.$toast.error("Error al enviar a aprobacion")
			}
		})
		this.para_aprobacion=false
	},
	editaOrden(orden) {
		this.ordenCompra.id=orden.id
		this.ordenCompra.documento=orden.documento
		this.ordenCompra.orden_compra=orden.numero
		this.ordenCompra.tipo=orden.tipo
		this.ordenCompra.fecha=orden.fecha
		this.ordenCompra.proveedor=orden.identificacion
		this.ordenCompra.items=orden.items
		this.ordenCompra.total=orden.valor_total
		this.para_aprobacion = true
	},
	f_creaOrden() {
		this.crea_orden = !this.crea_orden
	},
	formato(valor) {
		if (valor === null || valor === undefined || valor === '') {
			return ''
		}
		const valorStr = valor.toString().trim()
		const numero = parseFloat(valorStr)

		if (isNaN(numero)) {
			return valorStr
		}
		return new Intl.NumberFormat('en-US', { maximumFractionDigits: 0 }).format(numero)
	},
	f_check(boton) {
		if	(boton == 1) {
			let v_checked = document.getElementById("chk1").checked
			if	(v_checked  && this.partidaPresupuestal.length == 0) {
				this.$toast.error("Falta Informacion Presupuestal")
				document.getElementById("chk1").checked = false;
				v_checked=false
			}
			if	(v_checked) {
				this.partidaPresupuestalOK=true
			} else {
				this.partidaPresupuestalOK=false
			}
		}
		if	(boton == 2) {
			let v_checked = document.getElementById("chk2").checked
			if	(v_checked) {
				this.aprobacionProveedorOK=true
			} else {
				this.aprobacionProveedorOK=false
			}
		}
		if	(boton == 3) {
			let v_checked = document.getElementById("chk3").checked
			if	(v_checked) {
				this.cantidadCotizacionesOK=true
			} else {
				this.cantidadCotizacionesOK=false
			}
		}
		if	(!this.partidaPresupuestalOK ||
			!this.aprobacionProveedorOK ||
			!this.cantidadCotizacionesOK) {
			this.ordenValidada=false
		}
	},
	f_titulo_orden_compra() {
		if	(this.$route.name == "compras") {
			this.opcion=0
			return "ORDEN DE COMPRA "
		}
		if	(this.$route.name == "servicios") {
			this.opcion=0
			return "ORDEN DE SERVICIOS "
		}
		return this.$route.name + " SIN DEFINIR"
	},
	f_seleccione_productos() {
		Factura.leaProductos(this.pais,this.ordenCompra.proveedor)
		.then((res) => {
			this.listProductos = res.data.listProductos
		})
		.catch((err) => {
			console.log(err)
		})
	},
	creaItem(r_item) {
		if	(r_item.material == "") {
			return
		}
		let itemOrden = {
			material: r_item.material,
			cantidad: r_item.cantidad,
			unidad: r_item.unidad,
			monto_neto: r_item.monto_neto,
			precio_neto: r_item.precio_neto,
		}
		var v_items = 0
		var v_total = 0.0
		this.listItemsOrden.push(itemOrden)
		this.listItemsOrden.forEach((item) => {
			v_items+=1
			v_total+=parseFloat(item.precio_neto)
		})
		this.ordenCompra.items=v_items
		this.ordenCompra.total=v_total
		this.f_actualice_informacion()
		this.ordenCompra.material=''
		this.ordenCompra.cantidad=''
		this.ordenCompra.unidad=''
		this.ordenCompra.monto_neto=''
		this.ordenCompra.precio_neto=''
		document.getElementById("chk1").checked = false;
		document.getElementById("chk2").checked = false;
		document.getElementById("chk3").checked = false;
		this.partidaPresupuestal=""
		this.partidaPresupuestalOK=false
		this.aprobacionProveedorOK=false
		this.cantidadCotizacionesOK=false
		this.ordenValidada=false
	},
	formatNumber(value) {
		const valor = value ? value : 0
		return new Intl.NumberFormat('es-CO', { minimumFractionDigits: 2, maximumFractionDigits: 2 }).format(valor);
	}, 	
	f_actualice_informacion() {
		const v_tipo = this.tipoOrdenesCompra.filter((orden) => orden.tipo ==  this.ordenCompra.tipo)
		this.partidaPresupuestalRequerida=v_tipo[0].partida_presupuestal_requerida
		this.aprobacionProveedorRequerido=v_tipo[0].aprobacion_proveedor_requerido
		const v_nivel = this.tipoOrdenesAprobaciones.filter((orden) => orden.tipo==this.ordenCompra.tipo && parseFloat(orden.monto_maximo_aprobar) >=  parseFloat(this.ordenCompra.total))
		this.cantidadCotizaciones = v_nivel.length>0 ? v_nivel[0].cotizaciones : '0'
		this.nivelAprobacion = v_nivel.length>0 ? v_nivel[0].nivel : '0'
		this.aprobadorPorDefecto = v_tipo[0].aprobador_por_defecto
		let v_aprobadores = ""
		v_nivel.forEach((orden) => {
			const vl_nivel = orden.nivel
			const vl_aprobadores = this.tipoOrdenesAprobador.filter((aprobador) => aprobador.tipo == this.ordenCompra.tipo && aprobador.nivel == vl_nivel)
			vl_aprobadores.forEach((aprobador) => {
				const vl_email = aprobador.email 
				const v_usuario = this.users.filter((usuario) => usuario.email == vl_email)
				if	(v_usuario.length > 0) {
					if	(v_aprobadores.length==0) {
						v_aprobadores=v_usuario[0].name
					} else	{
						v_aprobadores=v_aprobadores+" - "+v_usuario[0].name
					}
				}
			})
		})
		if	(v_aprobadores.length==0) {
			this.aprobadores = "SIN DEFINIR"
		} else {
			this.aprobadores = v_aprobadores
		}

	},
	validaOrden() {
		this.ordenValidada=false
		if	(this.partidaPresupuestalOK && 
			this.cantidadCotizacionesOK && 
			this.aprobacionProveedorOK) {
			this.ordenValidada=true
		} else {
			const mensaje = this.partidaPresupuestalOK+"-"+
					this.cantidadCotizacionesOK+"-"+
					this.aprobacionProveedorOK+"-"+
					"Requisitos sin validar"
			this.$toast.error(mensaje)
		}
	},
	creaOrden(estado) {
		var v_orden =  {}
		v_orden.documento=this.documento
		v_orden.numero=this.ordenCompra.orden_compra
		v_orden.tipo=this.ordenCompra.tipo
		v_orden.fecha=this.ordenCompra.fecha
		v_orden.identificacion=this.ordenCompra.proveedor
		v_orden.items=this.ordenCompra.items
		v_orden.valor_total=this.ordenCompra.total
		v_orden.valor_entregado=0
		v_orden.partida_presupuestal_requerida=this.partidaPresupuestalRequerida
		v_orden.partida_presupuestal=this.partidaPresupuestal
		v_orden.partida_presupuestal_ok=this.partidaPresupuestalOK
		v_orden.cantidad_cotizaciones=this.cantidadCotizaciones
		v_orden.cantidad_cotizaciones_ok=this.cantidadCotizacionesOK
		v_orden.aprobacion_proveedor_requerido=this.aprobacionProveedorRequerido
		v_orden.aprobacion_proveedor_ok=this.aprobacionProveedorOK
		v_orden.nivel_minimo_aprobacion=this.nivelAprobacion
		v_orden.estado = estado
		v_orden.f_estado=this.ordenCompra.fecha
		v_orden.u_crea=this.$store.state.userId
		v_orden.itemsOrden = this.listItemsOrden
		Ordenes.grabaOrden(v_orden)
		.then((res) => {
			if	(res.status == 200) {
				this.$toast.success(res.data.message)
				this.muestreDetalleOrden=false
				this.ordenCompra={ proveedor:""}
				this.listItemsOrden = []
			} else {
				this.$toast.error(res.data.message)
			}
		})

	},
	cierreOrden() {
		this.muestreDetalleOrden=false
		this.ordenCompra={ proveedor:""}
		this.listItemsOrden = []
		document.getElementById("chk1").checked = false;
		document.getElementById("chk2").checked = false;
		document.getElementById("chk3").checked = false;
		this.para_aprobacion = false
	},
	f_actualiza_precio_neto(){
		if	(this.ordenCompra.cantidad != '' && this.ordenCompra.monto_neto != '') {
			this.ordenCompra.precio_neto = parseFloat(this.ordenCompra.cantidad) *
				parseFloat(this.ordenCompra.monto_neto)
		}
	},
}

}
</script>

<style>
table {
	table-layout:fixed;
}
.md-table-fixed-header-active {
	border-bottom: 20px solid;
}
.md-dialog::-webkit-scrollbar {
	width: 50px; /* Ancho de la barra de desplazamiento */
}
</style>
